import React, { useState } from "react";
import AnalyticStaff from "./AnalyticStaff";
import AnalyticProductionLine from "./AnalyticProductionLine";
import "./AdminReport.css";

function AdminReport({ onBack, onNavigateToSummary }) {
  const [reportPage, setReportPage] = useState("menu"); 
  // "menu" | "staff" | "production"

  return (
    <div className="admin-report-root">
      {/* REPORT MENU */}
      {reportPage === "menu" && (
        <div className="content">
          <button className="btn" onClick={() => setReportPage("staff")}>
            Staff
          </button>

          <button className="btn" onClick={() => setReportPage("production")}>
            Production Line
          </button>
        </div>
      )}

      {/* STAFF REPORT */}
      {reportPage === "staff" && (
        <AnalyticStaff onBack={() => setReportPage("menu")} />
      )}

      {/* PRODUCTION REPORT */}
      {reportPage === "production" && (
        <AnalyticProductionLine onBack={() => setReportPage("menu")} 
        onNavigateToSummary={onNavigateToSummary}
        />
      )}
    </div>
  );
}

export default AdminReport;
